import FeatureGates from '@atlaskit/feature-gate-js-client';

import { useIsEditorPluginAIEnabled } from './useEditorPluginAI';

export { useEditorAIReplacingTitle } from '@atlassian/editor-plugin-ai/ConfluenceSuggestTitleReactUtils';

export const useIsEditorAISuggestTitleInToolbarEnabled = (): boolean => {
	const experimentName = 'editor_ai_-_suggest_title_experiment';
	const cohort: string = FeatureGates.getExperimentValue(experimentName, 'cohort', 'not-enrolled');
	const issuggestTitleInTitleToolbarCohort = cohort === 'suggest-title';
	const isSuggestTitleInTitleToolbarEnabled: boolean = FeatureGates.getExperimentValue(
		experimentName,
		'isEnabled',
		false,
	);
	const editorAiEnabled = useIsEditorPluginAIEnabled();
	return (
		issuggestTitleInTitleToolbarCohort && isSuggestTitleInTitleToolbarEnabled && editorAiEnabled
	);
};
